(function () {
  'use strict';

  function initStickyAtc() {
    const bar = document.querySelector('.pbf-sticky-atc');
    if (!bar) return;

    const sectionId = bar.dataset.section;
    const infoWrapper = document.querySelector(
      '#MainProduct-' + sectionId + ' .product__info-wrapper'
    );
    const mainBtn = document.querySelector(
      '#MainProduct-' + sectionId + ' .pbf-pdp__atc'
    ) || document.querySelector(
      '#MainProduct-' + sectionId + ' .product-form__submit'
    );
    const stickyBtn = bar.querySelector('.pbf-sticky-atc__btn');

    if (!infoWrapper) return;

    const observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        var show = !entry.isIntersecting;
        bar.classList.toggle('pbf-sticky-atc--visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      },
      { threshold: 0 }
    );

    observer.observe(infoWrapper);

    if (stickyBtn && mainBtn) {
      stickyBtn.addEventListener('click', function () {
        mainBtn.click();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }
})();
